<h2 class="header">
  <ng-content></ng-content>
</h2>
